import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pos-session-list',
  templateUrl: './pos-session-list.component.html',
  styleUrls: ['./pos-session-list.component.css']
})
export class PosSessionListComponent implements OnInit {

  public menu_item_id = '74';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['session_no', 'start_time', 'cashier', 'machine', 'close_time',
    'cashier_close', 'view', 'close'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'pos_session', 'view_type': 'all', 'status': 'open',
    'from_date': new Date(), 'to_date': new Date()
  };

  viewList = [{ 'value': 'all', 'view_name': 'الكل', 'view_name_en': 'All' },
    { 'value': 'by_date', 'view_name': 'بالتاريخ', 'view_name_en': 'By Date' }];

  statusList = [{ 'value': 'all', 'status_ar': 'الكل', 'status_en': 'All' },
    { 'value': 'open', 'status_ar': 'مفتوح', 'status_en': 'Open' },
    { 'value': 'closed', 'status_ar': 'مغلق', 'status_en': 'Closed' }];

  Success_Msg; Error_Msg; Open; Closed;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Open').subscribe((res: string) => {
      this.Open = res;
    });

    translate.get('Closed').subscribe((res: string) => {
      this.Closed = res;
    });
  }


  ngOnInit() {
  }

  changeViewType() {
    if (this.model['view_type'] == 'by_date')
      this.model['status'] = 'all';
    else if (this.model['view_type'] == 'all')
      this.model['status'] = 'open';
  }

  search() {
    let condition = "";

    if (this.model['view_type'] == 'by_date') {

      if (this.model['from_date'] != undefined) {
        let from_date = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1)
          + "-" + this.model['from_date'].getDate() + ' 00:00:00');
        condition += " AND `pos_session`.`start_time` >= '" + from_date + "'";
      }
      if (this.model['to_date'] != undefined) {
        let to_date = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1)
          + "-" + this.model['to_date'].getDate() + ' 23:59:59');
        condition += " AND `pos_session`.`start_time` <= '" + to_date + "'";
      }

      if (this.model['status'] == 'open')
        condition += " AND `close_time` IS NULL";
      else if (this.model['status'] == 'closed')
        condition += " AND `close_time` IS NOT NULL";
    }

    else if (this.model['view_type'] == 'all')
      condition += " AND `close_time` IS NULL";

    let query = "SELECT `pos_session`.*, `sub_acct`.`sub_acct_name`, `sub_acct`.`sub_acct_name_en`" + 
      " FROM `pos_session`, `sub_acct` WHERE `pos_session`.`status` = '1'" + condition + 
      " AND `pos_session`.`cashier` = `sub_acct`.`acct_number`";
    //console.log(query);
    
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }
}
